// extracted by mini-css-extract-plugin
export default {"root":"ToBeResumedTable_root__qkD7i","rows":"ToBeResumedTable_rows__BeN5B","pagination":"ToBeResumedTable_pagination__7uNBu"};